
export const getComplianceAlertClass = (color) => {
  if (!color) return 'whiteAlert';

  const colorLower = color.toLowerCase().trim();

  switch (colorLower) {
    case 'red':
      return 'errorAlert';
    case 'amber':
      return 'amberAlert';
    case 'green':
      return 'successAlert';
    default:
      return 'whiteAlert';
  }
};


export const getComplianceHexColor = (color, withOpacity = false) => {
  if (!color) return withOpacity ? 'rgba(255, 255, 255, 0.15)' : '#ffffff';

  const colorLower = color.toLowerCase().trim();

  if (withOpacity) {
    switch (colorLower) {
      case 'red':
        return 'rgba(223, 0, 17, 0.15)';
      case 'amber':
        return 'rgba(255, 179, 0, 0.15)';
      case 'green':
        return 'rgba(79, 198, 5, 0.15)';
      default:
        return 'rgba(255, 255, 255, 0.15)';
    }
  } else {
    switch (colorLower) {
      case 'red':
        return '#DF0011';
      case 'amber':
        return '#FFB300';
      case 'green':
        return '#4FC605';
      default:
        return '#ffffff';
    }
  }
};
